// stores/serverTimeStore.js
import { create } from "zustand";

export const useServerTimeStore = create((set) => ({
    serverDateTime: null,
    connected: false,

    setServerTime: (time) =>
        set({ serverDateTime: time }),

    setConnected: (value) =>
        set({ connected: value }),
}));